import "./BannerPreview.css"
import Modal from '@mui/material/Modal';
import { BannerElement } from "../../types";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight, faCaretLeft } from "@fortawesome/free-solid-svg-icons";

interface BannerPreviewProps {
    openBannerPreview: boolean;
    setOpenBannerPreview: React.Dispatch<React.SetStateAction<boolean>>;
    bannerElements: BannerElement[]
}

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    borderRadius: "10px",
    boxShadow: 24,
    outline: 0,
    padding: "20px",
};

export const BannerPreview = (props: BannerPreviewProps) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    useEffect(()=>{
        setCurrentIndex(0);
    },[props.bannerElements])
    const increaseIndex = ()=>{
        setCurrentIndex((currentIndex+1)%props.bannerElements.length)
    }
    const decreaseIndex = ()=>{

        setCurrentIndex(currentIndex === 0 ? props.bannerElements.length-1 : currentIndex-1)
    }
    const handleClose = () => {
        props.setOpenBannerPreview(false);
    }


    return (
        <Modal
            open={props.openBannerPreview}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Typography id="modal-modal-description">
                    {props.bannerElements && props.bannerElements.length > 0 && currentIndex<props.bannerElements.length &&
                    <div className="banner-preview-container">
                        <div className="banner-element-container">
                            <FontAwesomeIcon icon={faCaretLeft} size="2x" onClick={decreaseIndex} style={{cursor: "pointer"}}/>
                            <img src={props.bannerElements[currentIndex].blobKey} className='banner-element-preview' />
                            <FontAwesomeIcon icon={faCaretRight} size="2x" onClick={increaseIndex} style={{cursor: "pointer"}}/>
                        </div>
                        <div className="banner-index">
                            {currentIndex + 1} / {props.bannerElements.length}
                        </div>
                    </div>
                    }

                    {(!props.bannerElements || props.bannerElements.length === 0) &&
                        <>No Banners Uploaded</>
                    }
                </Typography>
            </Box>

        </Modal>
    );
}